import { all, call } from "redux-saga/effects";
import onDeleteAudio from "./deleteAudio";
import onGetAudio from "./getAudio";

export default function* audioSagas() {
  yield all([call(onGetAudio), call(onDeleteAudio)]);
}
